import React, { useState } from 'react';
import { IMaskInput } from 'react-imask';

const CadastroModal = ({ aberto, aoFechar, aoEnviar }) => {
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [tipo, setTipo] = useState('');
  const [cidade, setCidade] = useState('');
  const [bairros, setBairros] = useState('');
  const [valorMin, setValorMin] = useState('');
  const [valorMax, setValorMax] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  if (!aberto) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nome || !whatsapp || !tipo || !cidade) {
      setErro('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    setErro('');
    setLoading(true);

    try {
      await aoEnviar({
        nome,
        whatsapp,
        tipo,
        cidade,
        bairros,
        valorMin,
        valorMax,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-2xl shadow-lg">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Novo Negócio</h2>
          <button className="text-gray-500 hover:text-black" onClick={aoFechar}>
            Fechar
          </button>
        </div>

        {erro && <p className="text-red-600 mb-2 font-medium">{erro}</p>}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* NOME */}
          <div>
            <label className="text-sm font-medium text-gray-600">
              Nome do cliente *
            </label>
            <input
              type="text"
              placeholder="Ex.: João Silva"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
            />
          </div>

          {/* WHATSAPP */}
          <div>
            <label className="text-sm font-medium text-gray-600">
              WhatsApp *
            </label>
            <IMaskInput
              mask="(00) 00000-0000"
              placeholder="(00) 00000-0000"
              value={whatsapp}
              onAccept={(v) => setWhatsapp(v)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
            />
          </div>

          {/* TIPO + VALORES */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Tipo */}
            <div>
              <label className="text-sm font-medium text-gray-600">
                Tipo de imóvel *
              </label>
              <select
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
              >
                <option value="">Selecione...</option>
                <option value="Casa">Casa</option>
                <option value="Apartamento">Apartamento</option>
                <option value="Terreno">Terreno</option>
                <option value="Kitnet">Kitnet</option>
                <option value="Comercial">Comercial</option>
              </select>
            </div>

            {/* Valor Min */}
            <div>
              <label className="text-sm font-medium text-gray-600">
                Valor mín. (R$)
              </label>
              <IMaskInput
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    thousandsSeparator: '.',
                    radix: ',',
                    mapToRadix: [','],
                  },
                }}
                unmask={true}
                value={valorMin}
                onAccept={(v) => setValorMin(v)}
                placeholder="Ex.: 200.000"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
              />
            </div>

            {/* Valor Max */}
            <div>
              <label className="text-sm font-medium text-gray-600">
                Valor máx. (R$)
              </label>
              <IMaskInput
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    thousandsSeparator: '.',
                    radix: ',',
                    mapToRadix: [','],
                  },
                }}
                unmask={true}
                value={valorMax}
                onAccept={(v) => setValorMax(v)}
                placeholder="Ex.: 450.000"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
              />
            </div>
          </div>

          {/* CIDADE + BAIRROS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-600">
                Cidade *
              </label>
              <input
                type="text"
                placeholder="Ex.: Sinop - MT"
                value={cidade}
                onChange={(e) => setCidade(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
              />
            </div>

            <div>
              <label className="text-sm font-medium text-gray-600">
                Bairros (vírgula)
              </label>
              <input
                type="text"
                placeholder="Centro, Flamboyants..."
                value={bairros}
                onChange={(e) => setBairros(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-1"
              />
            </div>
          </div>

          {/* BOTÕES */}
          <div className="flex justify-between items-center pt-2">
            <button
              type="button"
              className="text-gray-600 hover:text-black"
              onClick={aoFechar}
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={loading}
              className={`bg-emerald-600 text-white font-medium px-6 py-2 rounded-xl hover:bg-emerald-700 transition ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Salvando...' : 'Salvar negócio'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroModal;
